<template>
  <v-expansion-panel :disabled="disabled">
    <v-expansion-panel-header>
      <template v-slot:default="{ open }">
        <v-row no-gutters>
          <span style="margin-top: 5px">{{ title }}</span>
          <v-fade-transition>
            <span style="display: inline-flex" v-if="open & button_add">
              <v-divider class="mx-2" vertical/>
              <v-btn
                @click.native.stop="$emit('click_add')"
                color="primary" small
              >
                ADD
              </v-btn>
            </span>
          </v-fade-transition>
          <v-spacer/>
          <v-fade-transition>
            <span style="display: inline-flex" v-if="open">
                <slot name="header"/>
                <v-divider class="mx-1" vertical/>
            </span>
          </v-fade-transition>
        </v-row>
      </template>
      <template v-slot:actions>
        <v-icon :color="empty ? '' :'success'">
          mdi-chevron-down
        </v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <slot/>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import VueTypes from "vue-types";

export default {
  name: "r-panel",
  emits: ["click_add"],
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Panel"),
    empty: VueTypes.bool.def(true),
    button_add: VueTypes.bool.def(false)

  }
}
</script>